import { render, staticRenderFns } from "./PriceRulesList.vue?vue&type=template&id=2c7636a5&scoped=true&"
import script from "./PriceRulesList.vue?vue&type=script&lang=js&"
export * from "./PriceRulesList.vue?vue&type=script&lang=js&"
import style0 from "./PriceRulesList.vue?vue&type=style&index=0&id=2c7636a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7636a5",
  null
  
)

export default component.exports